<template>
    <a-spin class="no-select" :spinning="busy">
        <div class="vx-row w-full items-center">
            <span class="text-primary pl-8 w-10/12 text-2xl">{{ title.toUpperCase() }}</span>
            <a-icon v-show="!searchText.length" 
                :class="{ 'disabled' : disableAdd }" class="w-2/12 cursor-pointer text-red text-right mt-2" type="plus-circle" style="font-size: 18px"
                @click="$emit('add')" />
        </div>
        
        <div class="w-full" @click="saveOrder" v-show="hasChanges && !searchText.length" :key="title">
            <a-alert type="warning" message="Clique para salvar as alterações" show-icon class="mr-4 ml-4 mt-4 cursor-pointer" />
        </div>
        <vs-divider border-style="dashed" />

        <vs-input icon-pack="feather" icon="icon-search" placeholder="Procurar" v-model="searchText" class="w-full pr-4 pl-4 pb-4" />
        
        <ul class="chat__active-chats bordered-items">
            <draggable v-model="list" handle=".handle">
                <slot>
                    <SortableItem
                        class="list-item"
                        :class="{ 'cursor-pointer': !noSelect }"
                        v-for="item in filteredValues" :key="item.id"
                        :item="item"
                        :disableHandler="!!searchText.length"
                        :isSelected="selection == item.id"
                        :allowEdit="allowEdit"
                        @selected="setSelected"
                        @edit="(desc) => $emit('edit', item)"
                        @saveEditing="(desc) => $emit('saveEditing', item, desc)"
                        @deleteItem="$emit('disableItem', item)"
                    />
                </slot>
            </draggable>

            <div class="flex justify-center mt-8" style="opacity: 0.5">
                <h2 v-show="!filteredValues.length">Sem resultados</h2>
            </div>

        </ul>
    </a-spin>
</template>

<script>
import draggable from 'vuedraggable';

import SortableItem from './SortableItem';

import util from '@/assets/utils/misc';

export default {
    components: {
        SortableItem,
        draggable
    },
    props: {
        title: String,
        collectionName: String,
        customFilter: {
            type: Function,
            default: () => true
        },
        busy: Boolean,
        allowEdit: Boolean,
        disableAdd: Boolean,
        noSelect: Boolean,
        saveOrderPromise: Function
    },
    watch: {
        customFilter (val) {
            this.selection = null;
            this.list = this.allData.filter(val);
            this.order();
            this.originalOrder = [ ...this.list ];
        }
    },
    data() {
        return {
            allData: [],
            list: [],
            searchText: '',
            originalOrder: [],
            selection: null
        }
    },
    computed: {
        filteredValues: {
            get () {
                return this.searchText.length
                    ? this.list.filter(v => util.removeSpecialChars(v.description).includes(util.removeSpecialChars(this.searchText)))
                    : this.list;
            },
            set (v) { this.$emit('input', v); }
        },
        hasChanges() {
            return !!this.list.find((v, i) => this.originalOrder[i] != v);
        },
    },
    methods: {
        order () {
            // safer for numeric ordering
            this.list.sort((a,b) => Object.prototype.hasOwnProperty.call(a, 'order') && Object.prototype.hasOwnProperty.call(b, 'order')
                ? a.order - b.order 
                : (a.description > b.description) - (a.description < b.description)
            );
        },
        add (doc) {
            this.allData.push(doc);
            this.$emit('totalItems', this.allData.length);
            if (!this.customFilter(doc))
                return;
            this.list.push(doc);
            this.order();
            this.originalOrder = [ ...this.list ];
            this.$emit('fetchedValues', this.list);
        },
        onChange (doc) {
            this.list = this.list.filter(m => m.id != doc.id);
            this.allData = this.allData.filter(m => m.id != doc.id);
            this.add(doc);
        },
        async saveOrder () {
            try {
                this.$emit('update:busy', true);
                
                // callback here
                await this.saveOrderPromise(this.list);

                this.originalOrder = [ ...this.list ];

                this.$notification.success({
                    style: 'z-index: 9999999',
                    message: this.$t('success'),
                    description: 'Ordem alterada com sucesso'
                });
            } catch (err) {
                this.$store.commit('setError', err);
            } finally {
                this.$emit('update:busy', false);
            }
        },
        setSelected (item) {
            if (this.noSelect)
                return;
            this.selection = item.id;
            this.$emit('selected', item);
        },
        clear () {
            this.allData = this.list = [];
        },
        wipeOrder () {
            this.originalOrder = [];
        }
    },
}
</script>
<style scoped>
.no-select {
    user-select: none;
}
.disabled {
    color: #ccc;
    opacity: 0.5;
}
</style>